import { render } from "./company-group-contacts.vue?vue&type=template&id=02045987&ts=true"
import script from "./company-group-contacts.vue?vue&type=script&lang=ts"
export * from "./company-group-contacts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__